/**
 * Maximum regex pattern length. Caps extremely long patterns but does not
 * prevent all pathological backtracking from shorter expressions.
 */
const MAX_REGEX_LENGTH = 1000;

/**
 * Checks whether a string is a valid, safely-sized regex pattern.
 *
 * Mirrors `Panel/LogPanel/columnFilters/regexUtils.ts`. Copied (rather than
 * imported) because that file lives in a sibling domain and the function is
 * tiny.
 */
export function isValidRegex(pattern: string): boolean {
  if (pattern.length > MAX_REGEX_LENGTH) {
    return false;
  }
  try {
    new RegExp(pattern);
    return true;
  } catch {
    return false;
  }
}

/**
 * Returns the error message produced by `new RegExp(pattern)`, or `undefined`
 * if the pattern compiles successfully. Used for error tooltips.
 */
export function describeRegexError(pattern: string): string | undefined {
  if (pattern.length > MAX_REGEX_LENGTH) {
    return `Pattern exceeds ${MAX_REGEX_LENGTH} characters`;
  }
  try {
    new RegExp(pattern);
    return undefined;
  } catch (e) {
    return e instanceof Error ? e.message : String(e);
  }
}
